import(/* webpackMode: "eager", webpackExports: ["SettingsProvider"] */ "/codebuild/output/src2801287472/src/collinson-group-web/src/contexts/SettingsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2801287472/src/collinson-group-web/src/features/contentful/containers/StaticPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src2801287472/src/collinson-group-web/src/layouts/OpenAccessLayout.tsx");
